/* eslint-disable react/require-default-props */
import moment from 'moment';
import React from 'react';
import CardCounter from 'components/atoms/card_counter';
import SelectButton from 'components/atoms/select_button';
import { Container } from './styles';

interface ContractsHeaderProps {
  bidding_updated?: string;
  biddingId: string;
  biddingIndex: number;
  isChecked: boolean;
  toggleSelectedBiddings: (id: number, updateAll?: boolean) => void;
}

const ContractsHeader: React.FC<ContractsHeaderProps> = (props: ContractsHeaderProps) => {
  const { bidding_updated, biddingId, biddingIndex, isChecked, toggleSelectedBiddings } = props;

  return (
    <Container>
      <div className="card-header bidding-bg-header bidding-info">
        <div className="row align-items-center">
          <CardCounter count={biddingIndex + 1} />
          <div className="bidding-item-header-buttons d-flex align-self-start mb-2 mb-md-0 d-print-none">
            <div
              className="position-relative databalloon"
              aria-label="Selecionar contrato"
              data-balloon-pos="up"
            >
              <SelectButton
                id={parseInt(biddingId, 10)}
                isChecked={isChecked}
                toggleSelected={toggleSelectedBiddings}
                text=""
              />
            </div>
          </div>

          {/* {indexLabel} */}
          {bidding_updated && (
            <div className="ml-md-auto ml-2 text-white mr-2">
              <span className="font-weight-bold mr-2">Atualizada em</span>
              <span>{moment(bidding_updated).format('L LT')}</span>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
};

export default ContractsHeader;
